import { HandoverPackSectionFormModel } from './handoverPackSectionFormModel';

export type UpdateHandoverPackSectionDto = {
  sectionId: number;
} & HandoverPackSectionFormModel;

export const mapHandoverPackSectionFormModelToUpdateCommand = (
  sectionId: number,
  model: HandoverPackSectionFormModel,
): UpdateHandoverPackSectionDto => ({
  sectionId,
  ...model,
});
